import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MatSort, MatSortHeader, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Observable} from 'rxjs';
import {UsersDataSource} from '../../../data/source/UsersDataSource';
import {Role} from '../../../data/models/role';

@Component({
  selector: 'app-users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.css']
})
export class UsersTableComponent implements OnInit, OnChanges {

  @Input() displayedColumns!: string[];
  @Input() dataSource!: UsersDataSource;
  @Input() pageSizeOptions!: number[];
  @Input() pageSize!: number;
  @Input() pageNumber!: number;
  @Input() sort!: any[];

  @ViewChild(MatSort) matSort!: MatSort;
  @ViewChild(MatPaginator) matPaginator!: MatPaginator;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sort && this.matSort) {
      const sort = changes.sort.currentValue;
      (this.matSort.sortables.get(sort[0]) as MatSortHeader)
        ._setAnimationTransitionState({toState: 'active'});
    }
  }

  public get sort$(): Observable<Sort> {
    return this.matSort.sortChange.asObservable();
  }

  public get page$(): Observable<PageEvent> {
    return this.matPaginator.page.asObservable();
  }

  formatRoles(roles: Role[]): string {
    return roles.map(role => role.name).join(', ');
  }

}
